@if (currentStep) {
    <div class="configurator-action-bar">
        <div class="configurator-action-bar-stepper">
            @for (group of stepGroups; track $index) {
                <button type="button" class="configurator-action-bar-btn"
                        (mouseleave)="onLeaveStepGroupButton($event, group)"
                        (mouseenter)="onEnterStepGroupButton($event, group)" [class.locked]="group.locked"
                        [class.active]="group.active"
                        [class.completed]="group.completed"
                        [class.hovered]="group.hovered">
                    <div class="configurator-action-bar-btn-icon"
                         [ngbTooltip]="group.completed ? undefined : group.steps[0].label | translate"
                         placement="right">
                        @if (group.completed) {
                            @if (group.locked) {
                                <div class="badge">
                                    <fa-icon [icon]="['fas', 'lock']" size="lg"></fa-icon>
                                </div>
                            } @else {
                                <div class="badge">
                                    <fa-icon [icon]="['fas', 'check-circle']" size="lg"></fa-icon>
                                </div>
                            }
                        }
                        <fa-icon [icon]="[ group.active ? 'far' : 'fal', group.steps[0].icon]" size="lg"></fa-icon>
                    </div>
                </button>
                @if ($index < stepGroups.length - 1) {
                    <div class="btn-divider d-block d-lg-none">
                    </div>
                }
            }
        </div>
        <div class="configurator-action-bar-actions" [class.tour-active]="isTourActive">
            @if (chatService.isChatBotAvailable()) {
                <button type="button" class="configurator-action-bar-btn configurator-action-bar-chatbot-btn"
                        (click)="chatService.showChatbot()">
                    <div class="configurator-action-bar-btn-icon" [ngbTooltip]="'BTN_CHATBOT' | translate"
                         placement="right">
                        <img ngSrc="assets/img/chatBot/gerd.png" alt="Gerd" height="40" width="40">
                    </div>
                </button>
            }
            <button type="button" class="configurator-action-bar-btn"
                    (click)="cancelConfirm.show()">
                <div class="configurator-action-bar-btn-icon" [ngbTooltip]="'BTN_ABORT' | translate"
                     placement="right">
                    <fa-icon [icon]="['fal', 'times']" size="lg"></fa-icon>
                </div>
            </button>
        </div>
    </div>

    <shd-confirm-modal
        #cancelConfirm
        [title]="'SHARED_CANCEL_CONFIGURATION_TITLE' | translate"
        [question]="'SHARED_CANCEL_CONFIGURATION_QUESTION' | translate"
        (confirmed)="cancel()"></shd-confirm-modal>


    <app-chat-bot [title]="'CHATBOT_TITLE' | translate"></app-chat-bot>
}
